const getWpJson = async (url, proxyurl = '') => {
  try {
    const response = await fetch(proxyurl + url);
    const body = await response.json();
    return body;
  } catch (e){
    console.log(e)
  }
}

export default getWpJson;
